export default __webpack_public_path__ + "static/fagdag4-1bd6df238ee47fe46f48744902bde6c2.jpg";